import type { HelpFile } from '../../types/help'
import { AutoAssignRuleExecutionsTestIds } from '../../../testids/AutoAssignRuleExecutionsTestIds'

export const autoAssignRuleExecutionsHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [AutoAssignRuleExecutionsTestIds.autoAssignRuleExecutions]:
      'Historie der Auto-Assign-Regelläufe. Jede Zeile dokumentiert, wann eine Regel ausgewertet wurde, wie viele Identitäten zutrafen und wie viele Zugriffsberechtigungen hinzugefügt oder entzogen wurden.',
    [AutoAssignRuleExecutionsTestIds.btnClearRuleFilter]:
      'Den aktiven Regelfilter entfernen und Ausführungen aller Auto-Assign-Regeln anzeigen.',
    [AutoAssignRuleExecutionsTestIds.colRule]:
      'Auto-Zuweisungsregel, aus der diese Ausführung stammt.',
    [AutoAssignRuleExecutionsTestIds.colExecutedAt]:
      'Zeitstempel, zu dem die Regel ausgewertet wurde.',
    [AutoAssignRuleExecutionsTestIds.colStatus]:
      'Ergebnis der Ausführung — abgeschlossen, fehlgeschlagen oder teilweise angewendet.',
    [AutoAssignRuleExecutionsTestIds.colMatched]:
      'Anzahl der Identitäten, die in diesem Lauf der Regelbedingung entsprachen.',
    [AutoAssignRuleExecutionsTestIds.colAdded]:
      'Anzahl der hinzugefügten Berechtigungen, weil die zutreffenden Identitäten sie noch nicht hatten.',
    [AutoAssignRuleExecutionsTestIds.colRemoved]:
      'Anzahl der entzogenen Berechtigungen, weil Identitäten der Regelbedingung nicht mehr entsprachen.',
    [AutoAssignRuleExecutionsTestIds.colDuration]:
      'Vergangene Zeit (Wanduhr) zwischen Beginn und Ende der Ausführung.',
  },
}
